@use "styles/abstracts/mixins/typography" as t;
@use "styles/abstracts/variables" as v;

.event-list {
  font-style: normal;
  padding-left: 25px;

  &.not-available {
    color: v.$palette-gray-900;
    text-align: center;
    margin: 0;
    padding: 0;
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
  }
}

.not-available-bold {
  @include t.text(16px, 20px, 600);
}

.not-available-normal {
  @include t.text(14px, 22px, 400);
}
